"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AllServices = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _MerchandiseIds = require("self-service-api/constants/MerchandiseIds");

var _Hubs = _interopRequireDefault(require("self-service-api/constants/Hubs"));

var _Hubs$HUB_MARKETING$H;

var PrimaryServices = [_MerchandiseIds.SERVICE_INBOUND_CONSULTING_MONTHLY, _MerchandiseIds.SERVICE_INBOUND_CONSULTING_ONGOING, _MerchandiseIds.SERVICE_TECHNICAL_CONSULTING_ONGOING, _MerchandiseIds.SERVICE_PREMIUM_CONSULTING];
var AllServices = [].concat(PrimaryServices, [_MerchandiseIds.SERVICE_TRAINING_MARKETING_FUNDAMENTALS]);
exports.AllServices = AllServices;

var _default = (_Hubs$HUB_MARKETING$H = {}, (0, _defineProperty2.default)(_Hubs$HUB_MARKETING$H, _Hubs.default.HUB_MARKETING, {
  primaryMerch: AllServices
}), (0, _defineProperty2.default)(_Hubs$HUB_MARKETING$H, _Hubs.default.HUB_SALES, {
  primaryMerch: PrimaryServices
}), (0, _defineProperty2.default)(_Hubs$HUB_MARKETING$H, _Hubs.default.HUB_SERVICE, {
  primaryMerch: PrimaryServices
}), (0, _defineProperty2.default)(_Hubs$HUB_MARKETING$H, 'growth-suite', {
  primaryMerch: AllServices
}), _Hubs$HUB_MARKETING$H);

exports.default = _default;